export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.23-1417.53",
  commitId: "c8d190aec7bc1559307f66a0a3b5d09130f68dda",
  commitTime: "2026-07-23T14:17:53.000Z",
});
